import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';
import { UserApiV2, UserApiV2Request } from './types/User';

export type UserSettings = Partial<UserApiV2Request>;
export type userIdType = number | 'me';

const updateUser = (makeCall: MakeCall) => (
  userId: userIdType,
  data: UserSettings,
) =>
  makeCall<UserApiV2>('PUT', `${APIV2_URL}/user/${userId}`, {
    data,
  });

export default updateUser;
